export const themeMap: {
  [key: string]:
    | "violet"
    | "green"
    | "ruby"
    | "gray"
    | "gold"
    | "bronze"
    | "brown"
    | "yellow"
    | "amber"
    | "orange"
    | "tomato"
    | "red"
    | "crimson"
    | "pink"
    | "plum"
    | "purple"
    | "iris"
    | "indigo"
    | "blue"
    | "cyan"
    | "teal"
    | "mint"
    | "lime"
    | "sky";
} = {
  WOG: "violet",
  ELGIGANTEN: "green",
  DBG: "green",
  BG: "green",
  LOGITECH: "blue",
  STEELSERIES: "red",
  LEGO: "red",
  // Add more brand-theme mappings here
};

export const themeRadiusMap: {
  [key: string]: "none" | "small" | "medium" | "large" | "full";
} = {
  LOGITECH: "none",
  STEELSERIES: "none",
  LEGO: "none",
  // Add more brand-theme radius mappings here
};
